<script setup lang="ts">
import { useRouter, RouterLink } from "vue-router";

import LogoDark from "@/shared/components/atomic/svgs/logo/LogoDark.vue";
import RightUpArrow from "@/shared/components/atomic/svgs/right-up-arrow/RightUpArrow.vue";

const router = useRouter();

const footerNavigation = [
    // {
    //     label: "대시보드",
    //     path: "/dashboard",
    // },
    {
        label: "학생 관리",
        path: "/student-setting",
    },
    // {
    //     label: "반 관리",
    //     path: "/class-management",
    // },
    {
        label: "챌린지업",
        path: "/challenge-up",
    },
    {
        label: "튼튼개념쌓기",
        path: "/concept-enhancement",
    },
];
</script>

<template>
    <footer
        role="contentinfo"
        aria-label="사이트 정보 및 연락처"
        class="flex flex-col w-full items-center justify-start tablet:justify-between px-[3.2rem] py-[1.6rem] bg-surface-primary-dark"
    >
        <section class="size-full max-w-[112rem]">
            <div class="flex justify-between items-start py-7 w-full h-fit">
                <div class="inline-flex size-fit">
                    <LogoDark class="mb-[3.2rem] mr-[5.6rem]" />
                    <div
                        class="flex flex-wrap gap-[2.0rem] items-start justify-start mb-[2.4rem] mr-[2rem]"
                    >
                        <p
                            v-for="navigation in footerNavigation"
                            :key="navigation.label"
                            class="font-bold whitespace-nowrap cursor-pointer text-body-medium font-pretendard text-base-100 focus:outline-none focus:ring-2 focus:ring-base-100"
                            tabindex="0"
                            role="button"
                            :aria-label="`${navigation.label}로 이동`"
                            @click="router.push(navigation.path)"
                            @keydown.enter="router.push(navigation.path)"
                            @keydown.space.prevent="router.push(navigation.path)"
                        >
                            {{ navigation.label }}
                        </p>
                    </div>
                </div>

                <div class="flex flex-col gap-[1.9rem] items-start justify-start">
                    <a
                        class="inline-flex gap-3 justify-center items-center"
                        href="https://book.mathheart.net/"
                        target="_blank"
                    >
                        <p
                            class="font-bold whitespace-nowrap cursor-pointer text-body-medium font-pretendard text-base-100"
                        >
                            수심달스마트교재
                        </p>
                        <RightUpArrow class="text-base-100" />
                    </a>
                    <!-- <a
                        class="inline-flex gap-3 justify-center items-center"
                        href="https://susimdaledu.imweb.me/"
                        target="_blank"
                    >
                        <p
                            class="font-bold whitespace-nowrap cursor-pointer text-body-medium font-pretendard text-base-100"
                        >
                            수심달클래스
                        </p>
                        <RightUpArrow class="text-base-100" />
                    </a> -->
                </div>
            </div>
            <div class="flex flex-col items-start justify-start py-7 gap-[0.8rem]">
                <div class="flex justify-items-start gap-[0.8rem]">
                    <div class="inline-flex justify-items-start gap-[0.8rem]">
                        <p class="font-normal text-body-small font-pretendard text-base-100">
                            (주)수학에심장을달다
                        </p>
                        <p class="font-normal text-body-small font-pretendard text-base-100">
                            대표자: 이정환
                        </p>
                    </div>
                    <p class="font-normal text-body-small font-pretendard text-base-100">
                        서울특별시 강서구 화곡로 347,303호 (화곡동, 그랜드아이파크)
                    </p>
                </div>

                <div class="flex justify-items-start gap-[0.8rem]">
                    <div class="inline-flex justify-items-start gap-[0.8rem]">
                        <p class="font-bold text-body-small font-pretendard text-base-100">
                            사업자등록번호
                        </p>
                        <p class="font-normal text-body-small font-pretendard text-base-100">
                            585-81-01931
                        </p>
                    </div>
                    <div class="flex justify-items-start gap-[0.8rem]">
                        <div class="inline-flex justify-items-start gap-[0.8rem]">
                            <p class="font-bold text-body-small font-pretendard text-base-100">
                                고객센터
                            </p>
                            <p class="font-normal text-body-small font-pretendard text-base-100">
                                1899-3884
                            </p>
                        </div>
                        <div class="inline-flex justify-items-start gap-[0.8rem]">
                            <p class="font-bold text-body-small font-pretendard text-base-100">
                                운영 시간
                            </p>
                            <p class="font-normal text-body-small font-pretendard text-base-100">
                                평일 09:00~19:00 (점심시간 13:00~14:00)
                            </p>
                        </div>
                    </div>
                    <!-- <div class="inline-flex justify-items-start gap-[0.8rem]">
                        <p class="font-bold text-body-small font-pretendard text-base-100">
                            통신판매업신고번호
                        </p>
                        <p class="font-normal text-body-small font-pretendard text-base-100">
                            2025-서울강서-2044
                        </p>
                    </div> -->
                </div>
            </div>
            <div class="w-full h-[1px] bg-base-100 mb-[2.4rem]"></div>
            <div class="inline-flex justify-end w-full">
                <p class="font-normal text-body-small font-pretendard text-base-100">
                    All rights reserved
                </p>
            </div>
        </section>
    </footer>
</template>
